export const ChapterArt = ({ testId, light = false }) => {
  const strokeA = light ? "#EAE6DF" : "#1A1A1A";
  const strokeB = light ? "#EAE6DF" : "#7A8475";
  return (
    <div
      className="pointer-events-none absolute right-6 top-[40px] sm:top-[58px]"
      data-testid={testId}
      aria-hidden="true"
    >
      <svg
        className="absolute -inset-10 h-[calc(100%+5rem)] w-[calc(100%+5rem)]"
        viewBox="0 0 220 220"
        preserveAspectRatio="xMidYMid slice"
      >
        <rect x="140" y="16" width="64" height="64" fill="none" stroke={strokeA} strokeOpacity={light ? 0.3 : 0.16} strokeDasharray="3 6" vectorEffect="non-scaling-stroke" />
        <rect x="14" y="140" width="56" height="56" fill="none" stroke={strokeB} strokeOpacity={light ? 0.4 : 0.3} strokeDasharray="3 6" vectorEffect="non-scaling-stroke" />
        <rect x="160" y="160" width="40" height="40" fill="none" stroke={strokeA} strokeOpacity={light ? 0.22 : 0.12} strokeDasharray="3 6" vectorEffect="non-scaling-stroke" />
      </svg>
      <img src="/images/cluster.png" alt="" className="relative w-28 rotate-90 sm:w-[140px]" />
    </div>
  );
};
